module.exports = __webpack_public_path__ + "img/p1.36abd7b8.png";